export default "__VITE_ASSET__9bc8ea0d__"